import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { deFondo } from "../security/helper/peticion-de-fondo";
import { UrlConstantes } from "../utilerias/constantes/urlconstantes";
import {
  Mantenimiento,
  MantenimientoReq,
  MantenimientoRes,
} from "../shared/model/mantenimiento/mantenimiento.model";

/**
 * Mantenimiento: instalaciones y edificio.
 *
 * El usuario y su empresa NUNCA viajan: los pone el servidor desde la
 * sesión. Las reglas (quién mueve qué, a qué estatus) también viven allá;
 * la pantalla solo decide qué botones enseñar.
 */
@Injectable({ providedIn: "root" })
export class MantenimientoService {
  constructor(private http: HttpClient) {}

  /** Lo del propio colaborador: sus solicitudes y si además atiende. */
  mias(fondo = false): Observable<MantenimientoRes> {
    return this.http.post<MantenimientoRes>(UrlConstantes.MANTENIMIENTO_MIAS, {}, fondo ? { context: deFondo() } : {});
  }

  solicitar(solicitud: Mantenimiento): Observable<MantenimientoRes> {
    const req: MantenimientoReq = { solicitud };
    return this.http.post<MantenimientoRes>(UrlConstantes.MANTENIMIENTO_SOLICITAR, req);
  }

  /** La bandeja de quien atiende. `fondo` para el refresco automático, sin velo. */
  bandeja(req: MantenimientoReq, fondo = false): Observable<MantenimientoRes> {
    return this.http.post<MantenimientoRes>(UrlConstantes.MANTENIMIENTO_BANDEJA, req, fondo ? { context: deFondo() } : {});
  }

  detalle(idSolicitud: number, fondo = false): Observable<MantenimientoRes> {
    const req: MantenimientoReq = { idSolicitud };
    return this.http.post<MantenimientoRes>(UrlConstantes.MANTENIMIENTO_DETALLE, req, fondo ? { context: deFondo() } : {});
  }

  tomar(idSolicitud: number): Observable<MantenimientoRes> {
    return this.http.post<MantenimientoRes>(UrlConstantes.MANTENIMIENTO_TOMAR, { idSolicitud });
  }

  reasignar(idSolicitud: number, idUsuarioResponsable: number): Observable<MantenimientoRes> {
    return this.http.post<MantenimientoRes>(UrlConstantes.MANTENIMIENTO_REASIGNAR, { idSolicitud, idUsuarioResponsable });
  }

  /** En espera, de vuelta en atención, resuelta o no procede. Siempre con comentario. */
  mover(idSolicitud: number, estatus: string, comentario: string): Observable<MantenimientoRes> {
    return this.http.post<MantenimientoRes>(UrlConstantes.MANTENIMIENTO_MOVER, { idSolicitud, estatus, comentario });
  }

  confirmar(idSolicitud: number, comentario?: string | null): Observable<MantenimientoRes> {
    return this.http.post<MantenimientoRes>(UrlConstantes.MANTENIMIENTO_CONFIRMAR, { idSolicitud, comentario });
  }

  reabrir(idSolicitud: number, comentario: string): Observable<MantenimientoRes> {
    return this.http.post<MantenimientoRes>(UrlConstantes.MANTENIMIENTO_REABRIR, { idSolicitud, comentario });
  }

  cancelar(idSolicitud: number, comentario?: string | null): Observable<MantenimientoRes> {
    return this.http.post<MantenimientoRes>(UrlConstantes.MANTENIMIENTO_CANCELAR, { idSolicitud, comentario });
  }

  comentar(idSolicitud: number, comentario: string): Observable<MantenimientoRes> {
    return this.http.post<MantenimientoRes>(UrlConstantes.MANTENIMIENTO_COMENTAR, { idSolicitud, comentario });
  }

  subirFoto(idSolicitud: number, archivo: File): Observable<MantenimientoRes> {
    const forma = new FormData();
    forma.append("file", archivo, archivo.name);
    forma.append("idSolicitud", String(idSolicitud));
    return this.http.post<MantenimientoRes>(UrlConstantes.MANTENIMIENTO_FOTO_SUBIR, forma);
  }

  /** Los bytes de la foto, por HttpClient para que viaje el token. De fondo: son miniaturas. */
  verFoto(idFoto: number): Observable<Blob> {
    return this.http.post(UrlConstantes.MANTENIMIENTO_FOTO_VER, { idFoto }, { responseType: "blob", context: deFondo() });
  }

  quitarFoto(idFoto: number): Observable<MantenimientoRes> {
    return this.http.post<MantenimientoRes>(UrlConstantes.MANTENIMIENTO_FOTO_QUITAR, { idFoto });
  }
}
